import InfoIcon from '@material-ui/icons/Info';
import SecondaryButton from '../core/SecondaryButton';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import GS from '../grafsync/grafsync';

const styles = theme => ({
  close: {
    padding: theme.spacing(0.5),
  },
});

class EventSnack extends React.Component {

  state = {
    open: true
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    this.setState({ open: false });
  };

  hideNotifications = () => {
    GS.setHideNotifications();
    this.handleClose();
  };

  render() {

    const { classes } = this.props;

    return (
      <div>
        <Snackbar
          data-test="snack"
          style={{
            maxWidth: 800
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          key={this.props.message}
          open={this.state.open}
          autoHideDuration={10000}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={
            <div data-test="snack-text" id="message-id">
              <div style={{ display: 'flex' }}>
                <div style={{ marginRight: 4 }}>
                  <InfoIcon fontSize='large' style={{ verticalAlign: 'middle', transform: 'translateY(6px)' }} />
                </div>
                {this.props.message}
                {this.props.additionalMessage}
              </div>
              <div style={{ textAlign: 'right', marginTop: 12 }}>
                <SecondaryButton
                  dataTest="hide-notifications"
                  compact={true}
                  onClick={this.hideNotifications}>Disable Notifications</SecondaryButton>
              </div>
            </div>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.handleClose}>
              <CloseIcon />
            </IconButton>
          ]}
        />
      </div>
    );
  }
}

EventSnack.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(EventSnack);